// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"bfd8d9bd","221":"756d5d6d","324":"95d4dd35","453":"b5b27b69","569":"e1fa614a"}[chunkId] + ".chunk.js";
};